




























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { ActivityList } from '@/@types/LibraryComponent';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

@Component
export default class ActivityCard extends Vue {
  @Prop(Object) public activity!: ActivityList;

  private mounted() {
    this.activity.createdAt = dayjs(this.activity.createdAt).fromNow();
  }

  private accountImage(imageUrl: string) {
    return require('../../assets/' + imageUrl);
  }
}
